import { ReactNode } from 'react';
import { Flame } from 'lucide-react';

/** Gemeinsamer Rahmen aller Seiten, die ohne Anmeldung erreichbar sind. */
export function AuthLayout({
  titel,
  untertitel,
  children,
  fusszeile,
}: {
  titel: string;
  untertitel?: ReactNode;
  children: ReactNode;
  fusszeile?: ReactNode;
}) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-12">
      <div className="w-full max-w-md">
        <div className="mb-8 flex flex-col items-center">
          <Flame className="h-10 w-10 text-primary-600" />
          <h1 className="mt-3 text-xl font-semibold text-gray-900">BRANTAS</h1>
          <p className="text-sm text-gray-600">Software · Brandschutz Dokumentation</p>
        </div>

        <div className="rounded-lg border border-gray-200 bg-white p-8 shadow-sm">
          <h2 className="text-lg font-semibold text-gray-900">{titel}</h2>
          {untertitel && <p className="mt-1 text-sm text-gray-600">{untertitel}</p>}
          <div className="mt-6">{children}</div>
        </div>

        {fusszeile && (
          <div className="mt-6 text-center text-sm text-gray-600">{fusszeile}</div>
        )}
      </div>
    </div>
  );
}

/** Einheitliche Fehleranzeige -- inklusive der Feldmeldungen aus 422. */
export function Fehlermeldung({ fehler }: { fehler: unknown }) {
  if (!fehler) return null;

  const details = (fehler as any)?.details as
    | Array<{ feld: string; meldung: string }>
    | undefined;
  const text =
    (fehler as any)?.response?.data?.error ??
    (fehler as Error)?.message ??
    'Unbekannter Fehler';

  return (
    <div
      role="alert"
      className="mb-4 rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-800"
    >
      <p>{text}</p>
      {details && details.length > 0 && (
        <ul className="mt-2 list-inside list-disc">
          {details.map((d, i) => (
            <li key={i}>
              <span className="font-medium">{d.feld}</span>: {d.meldung}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default AuthLayout;
